<template>
  <div class="main">
    <nav class="top_flex">
      <van-tabs @click="tabChange" v-model="navIndex" swipeable>
        <van-tab
          v-for="(item, index) in navList"
          :title="item.name"
          :key="index"
        >
        </van-tab>
      </van-tabs>
    </nav>
    <keep-alive :include="['Home', 'fictionList']">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "Layout",
  data() {
    return {
      navIndex: 0,
      navList: [],
    };
  },
  created() {
    let query = this.$route.query;
    let sectionId = query.sectionId;
    this.fetchNavIgation().then((res) => {
      this.navList = res.data;
      this.navIndex = this.navList.findIndex((r) => r.id == sectionId) || 0;
      this.$router.push({ path: "/", query });
    });
  },

  methods: {
    ...mapActions("userIndex", ["fetchNavIgation"]),
    tabChange(idx, name) {
      window.scroll(0, 0);
      let item = this.navList[idx];
      let query = {
        sectionId: item.id,
        platform: this.$route.query.platform,
      };
      this.$router.push({
        path: "/",
        query,
      });
    },
  },
};
</script>
